import React from 'react';
import MarketingCallout from '../MarketingCallout';

export default function MarketingAboutAnchor() {
  return (
    <div>
      <MarketingCallout
        direction="left"
        bgColor="#2EFFD9"
        prevBgColor="#2EFFD9"
        nextBgColor="#EB9FEF"
        isFirst
        height={270}
      >
        <h3 style={{ color: '#8940FA' }}>Record your voice.</h3>
        <p style={{ color: '#292F36' }}>
          Record your voice or any audio around you in seconds; it’s as easy as
          talking on the phone. (Seriously.)
        </p>
      </MarketingCallout>
      <MarketingCallout
        direction="right"
        bgColor="#EB9FEF"
        prevBgColor="#2EFFD9"
        nextBgColor="#8940FA"
        height={320}
      >
        <h3>The easiest way to start a podcast, ever.</h3>
        <p>
          Once you’ve added some audio to the app, just choose a name for your
          podcast and you’re done. That’s literally it.
        </p>
      </MarketingCallout>
      <MarketingCallout
        direction="left"
        bgColor="#8940FA"
        prevBgColor="#EB9FEF"
        nextBgColor="#292F36"
        height={380}
      >
        <h3>Interview your friends.</h3>
        <p>
          Call anyone you know and capture the conversation, even if they don’t
          have the Anchor app installed. Broadcast and share the audio right
          from your phone.
        </p>
      </MarketingCallout>
      <MarketingCallout
        direction="right"
        bgColor="#292F36"
        prevBgColor="#8940FA"
        nextBgColor="#292F36"
        isLast
        height={360}
      >
        <h3>
          Add real music from <br className="hidden-sm" />
          Apple&nbsp;Music and Spotify.
        </h3>
        <p style={{ color: '#2EFFD9', paddingBottom: 80 }}>
          Add any track from your favorite services to your Anchor station!
          Listeners with premium accounts can even stream the full&nbsp;song.
        </p>
      </MarketingCallout>
    </div>
  );
}
